export default "__VITE_ASSET__BOLMsHp1__"